import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-152" data-mp="bq9furzo3c1a">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-153" data-mp="195wrtb2xzn8w">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex min-h-[60px] w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-gold px-5 py-3 text-center text-base font-black uppercase tracking-wide text-ink shadow-[0_6px_0_0_#8f6c1c,0_16px_40px_-8px_rgba(0,0,0,0.5)] ring-2 ring-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/60" data-id="element-154" data-mp="2f40yg72i4po2">
            <span data-id="element-155" data-mp="1we2i73ojvq9c">Get it now for $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-156" data-mp="1wf44y5exi16w" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}